module.exports = __webpack_public_path__ + "img/179945.53caf56d.png";